
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"16","viewBox":"0 0 20 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 4v1.5c0 .281-.25.5-.5.5a.494.494 0 01-.5-.5V4a3 3 0 016 0v.125c0 .719-.063 1.438-.188 2.156l4.532-1.25a.572.572 0 01.531.188c.125.125.156.343.063.531L13.28 9.031H17.5c.25 0 .5.219.5.5 0 .25-.25.5-.5.5h-5a.499.499 0 01-.438-.25.566.566 0 01-.03-.5l1.5-3-3.907 1.094c-.063.188-.094.406-.156.594l-.219.812a17.08 17.08 0 01-1.531 3.656l-.844 1.532A2.126 2.126 0 015.062 15 2.04 2.04 0 013 12.937v-2.906c0-1.125.75-2.094 1.844-2.406L8.75 6.562C8.906 5.75 9 4.938 9 4.126V4c0-1.094-.906-2-2-2-1.125 0-2 .906-2 2zm.094 4.594c-.657.187-1.125.781-1.125 1.437v2.906c0 .594.5 1.063 1.094 1.063.375 0 .75-.188.937-.531l.844-1.5A15.333 15.333 0 008.28 8.5l.219-.781v-.063l-3.406.938zM.5 12h1c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-1a.494.494 0 01-.5-.5c0-.25.219-.5.5-.5zm10 0h9c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-9a.494.494 0 01-.5-.5c0-.25.219-.5.5-.5z","fill":"#212121"}})])
          )
        }
      }
    